import { render, staticRenderFns } from "./MentionsView.vue?vue&type=template&id=426d361e&scoped=true"
var script = {}
import style0 from "./MentionsView.vue?vue&type=style&index=0&id=426d361e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426d361e",
  null
  
)

export default component.exports